import { APIMemberData } from "@companion-core/shared/app/Interfaces/API";
import { organizationSizes } from "@companion-core/shared/app/Constants/organization";
import { getCountries } from "libphonenumber-js";

export type PhoneInfos = {
  type: string;
  phone: string;
};

export type PersonalInfoConfigField = {
  type: string;
  [key: string]: string;
};

export type SelectOption = {
  value: string;
  text: string;
};

export type FormErrors = {
  [key: string]: string[];
};

export type PersonalInformationPayload = {
  personal_home_phone?: string;
  personal_mobile_phone?: string;
  professional_mobile_phone?: string;
  addresses: APIMemberData["addresses"];
  organization: APIMemberData["organization"];
};

export function getAvailableFields(
  name: string,
  resource: Record<string, Record<string, []>>,
): string[] {
  const availableFieldsList: string[] = [];
  resource?.forms[`${name}`]?.map((field: PersonalInfoConfigField) =>
    availableFieldsList.push(field.type),
  );
  return availableFieldsList;
}

export function getOrganizationSizes() {
  return organizationSizes.map((value) => ({ text: value, value }));
}

export function getCountriesOptions() {
  return getCountries().map((countryCode) => ({
    text: `common.countries.${countryCode.toLowerCase()}`,
    value: countryCode,
  }));
}
